import { useEffect } from 'react';

import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (!hash) {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'auto',
      });

      return;
    }

    const id = hash.substring(1);

    let observer: ResizeObserver | null = null;
    let stopTimeout: number | null = null;
    let findTimeout: number | null = null;
    let hasScrolled = false;

    const scrollToTarget = () => {
      const element = document.getElementById(id);

      if (!element) {
        findTimeout = window.setTimeout(scrollToTarget, 50);

        return;
      }

      element.scrollIntoView({
        behavior: hasScrolled ? 'auto' : 'smooth',
        block: 'start',
      });

      hasScrolled = true;

      if (!observer) {
        observer = new ResizeObserver(() => {
          const currentElement = document.getElementById(id);

          if (currentElement) {
            currentElement.scrollIntoView({
              behavior: 'auto',
              block: 'start',
            });
          }
        });

        observer.observe(document.body);

        stopTimeout = window.setTimeout(() => {
          observer?.disconnect();
          observer = null;
        }, 2000);
      }
    };

    findTimeout = window.setTimeout(scrollToTarget, 50);

    return () => {
      if (findTimeout !== null) {
        window.clearTimeout(findTimeout);
      }

      if (stopTimeout !== null) {
        window.clearTimeout(stopTimeout);
      }

      observer?.disconnect();
    };
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;